import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import Icon from 'react-native-vector-icons/Ionicons';
import colors from '../../util/colors';
import { mvs } from '../../util/metrices';
import HomeStack from '../HomeStack';
import AllDevotionsScreen from '../../screens/App/AllDevotions';
import LoginScreen from '../../screens/Auth/Login';
import UserProfileScreen from '../../screens/App/UserProfile';
import { useAuth } from '../../context/AuthContext';

const Tab = createBottomTabNavigator();

const MyTabs = () => {
  const { isAuthenticated } = useAuth();
  React.useEffect(() => {
    console.log('🧭 MyTabs mounted.');
  }, [isAuthenticated]);

  return (
    <Tab.Navigator
      initialRouteName="Home"
      screenOptions={({ route }) => ({
        headerShown: false,
        tabBarShowLabel: false,
        tabBarStyle: styles.tabBar,
        tabBarIcon: ({ focused }) => {
          let iconName;
          let label;
          switch (route.name) {
            case 'Home':
              iconName = focused ? 'home' : 'home-outline';
              label = 'Home';
              break;
            case 'Calendar':
              iconName = focused ? 'calendar' : 'calendar-outline';
              label = 'Devotions';
              break;
            case 'User':
              iconName = focused ? 'person' : 'person-outline';
              label = isAuthenticated ? 'Profile' : 'Login';
              break;
            default:
              iconName = 'home-outline';
          }
          return (
            <View style={styles.iconContainer}>
              <Icon
                name={iconName}
                size={24}
                color={focused ? colors.primary : colors.textSecondary}
              />
              <Text
                style={[
                  styles.label,
                  { color: focused ? colors.primary : colors.textSecondary },
                ]}>
                {label}
              </Text>
            </View>
          );
        },
      })}
    >
      <Tab.Screen name="Home" component={HomeStack} />
      <Tab.Screen name="Calendar" component={AllDevotionsScreen} />
      <Tab.Screen
        name="User"
        component={isAuthenticated ? UserProfileScreen : LoginScreen}
      />
    </Tab.Navigator>
  );
};

const styles = StyleSheet.create({
  tabBar: {
    backgroundColor: colors.surface,
    height: mvs(75),
    paddingBottom: mvs(8),
    paddingTop: mvs(8),
    borderTopWidth: 1,
    borderTopColor: colors.accent,
    shadowColor: colors.primary,
    shadowOffset: {
      width: 0,
      height: -2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 8,
  },
  label: {
    fontSize: 11,
    textAlign: 'center',
    width: 60,
    marginTop: mvs(8),
    fontFamily: 'DMSans-Regular',
  },
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: mvs(10),
  },
});

export default MyTabs;
